<div class="app-main">
  <app-header
    [headerIsAsideEnabled]="isAsideEnabled"
    data-cy="main-header"
  ></app-header>
  <div
    id="app-main__container"
    class="app-main__container"
  >
    @if (isAsideEnabled) {
      <app-aside data-cy="main-aside"></app-aside>
    }
    <div
      class="main-content"
      [class.main-content--with-appcues-banner]="isAppcuesBannerVisible"
      [class.main-content--collapsed]="isAsideEnabled && isAsideCollapsed"
      [class.main-content--full-width]="!isAsideEnabled"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
